import { useEffect } from 'react'
import { startDeferredEventFlushLoop } from '../services/deferredEventOutbox'
import { useAuth } from '../context/useAuth'

export const DeferredEventOutboxBridge = () => {
  const { currentUser } = useAuth()

  useEffect(() => {
    if (!currentUser?.uid) return undefined
    return startDeferredEventFlushLoop()
  }, [currentUser?.uid])

  return null
}
